class ProductComparison {
  constructor() {
    this.storageKey = 'racket_comparison';
    this.maxProducts = 3;
    this.init();
  }

  init() {
    this.updateButtonStates();
    this.updateComparisonCount();
  }

  getComparisonList() {
    const stored = localStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : [];
  }

  saveComparisonList(list) {
    localStorage.setItem(this.storageKey, JSON.stringify(list));
    this.updateComparisonCount();
  }

  addProduct(productId, productTitle, productUrl, productImage, productVendor) {
    let list = this.getComparisonList();
    
    if (list.find(p => p.id === productId)) {
      this.showNotification('Bu ürün zaten karşılaştırma listesinde!', 'warning');
      return;
    }

    if (list.length >= this.maxProducts) {
      this.showNotification(`En fazla ${this.maxProducts} ürün karşılaştırabilirsiniz!`, 'error');
      return;
    }

    list.push({
      id: productId,
      title: productTitle,
      url: productUrl,
      image: productImage,
      vendor: productVendor
    });

    this.saveComparisonList(list);
    this.updateButtonStates();
    this.showNotification('Ürün karşılaştırma listesine eklendi!', 'success');
  }

  removeProduct(productId) {
    let list = this.getComparisonList();
    list = list.filter(p => p.id !== productId);
    this.saveComparisonList(list);
    this.updateButtonStates();
    
    if (window.location.pathname.includes('/pages/raket-karsilastirma')) {
      location.reload();
    }
  }

  clearAll() {
    localStorage.removeItem(this.storageKey);
    this.updateComparisonCount();
    if (window.location.pathname.includes('/pages/raket-karsilastirma')) {
      location.reload();
    }
  }

  updateButtonStates() {
    document.querySelectorAll('[data-compare-button]').forEach(button => {
      const productId = button.dataset.productId;
      const list = this.getComparisonList();
      const isInList = list.find(p => p.id === productId);
      
      if (isInList) {
        button.classList.add('in-comparison');
        button.textContent = '✓ Karşılaştırmada';
      } else {
        button.classList.remove('in-comparison');
        button.textContent = 'Karşılaştır';
      }
    });
  }

  updateComparisonCount() {
    const count = this.getComparisonList().length;
    document.querySelectorAll('[data-comparison-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-block' : 'none';
    });
  }

  showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `comparison-notification comparison-notification--${type}`;
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => notification.classList.add('show'), 10);
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
}

// Initialize
const productComparison = new ProductComparison();

// Event delegation for compare buttons
document.addEventListener('click', (e) => {
  const button = e.target.closest('[data-compare-button]');
  if (button) {
    e.preventDefault();
    const { productId, productTitle, productUrl, productImage, productVendor } = button.dataset;
    
    if (button.classList.contains('in-comparison')) {
      productComparison.removeProduct(productId);
    } else {
      productComparison.addProduct(productId, productTitle, productUrl, productImage, productVendor);
    }
  }

  if (e.target.closest('[data-clear-comparison]')) {
    e.preventDefault();
    if (confirm('Tüm karşılaştırma listesini temizlemek istediğinize emin misiniz?')) {
      productComparison.clearAll();
    }
  }

  if (e.target.closest('[data-remove-from-comparison]')) {
    e.preventDefault();
    const productId = e.target.closest('[data-remove-from-comparison]').dataset.productId;
    productComparison.removeProduct(productId);
  }
});
